import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ConspiracyBoard from "@/pages/ConspiracyBoard";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ConspiracyBoard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        toastOptions={{
          style: {
            background: "#1a140c",
            color: "#f4ebd8",
            border: "1px solid rgba(180,140,90,0.25)",
            fontFamily: "'Special Elite', monospace",
          },
        }}
      />
    </div>
  );
}

export default App;
